import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";

import {productGroupService} from "../../../services/settings-services";


const initialState = {
    productGroups: [],
    error: null,
    trigger: 0,
    isLoading: false,
}

const getAllProductGroups = createAsyncThunk(
    'menuCategoriesSlice/getAllProductGroups',
    async (_, {rejectWithValue}) => {
        try {
            return  await productGroupService.getAll();
        }catch (e) {
            return rejectWithValue(e.response?.data?.message || "Something went wrong");
        }
    }
);


const productGroupsSlice = createSlice({
    name: 'productGroupsSlice',
    initialState,
    reducers: {
        changeTrigger: (state, action) => {
            state.trigger = state.trigger + 1;
        },
    },
    extraReducers: builder =>
        builder
            .addCase(getAllProductGroups.pending, state => {
                state.error = null;
                state.isLoading = true;
            })
            .addCase(getAllProductGroups.fulfilled, (state, action) => {
                state.productGroups = action.payload;
                state.isLoading = false;
            })
            .addCase(getAllProductGroups.rejected, (state, action) => {
                state.error = action.payload;
                state.isLoading = false;
            })
});

const {reducer: productGroupsReducer, actions} = productGroupsSlice;
const productGroupsActions = {
    ...actions,
    getAllProductGroups
}

export {productGroupsReducer,
    productGroupsActions
}